import * as m from 'mithril';
import AppContext from '../context/AppContext';

import { TripSearchFsmScheme } from '../states/trip-search/TripSearchFsmScheme';
import TripSearchPage from '../pages/tripresult/TripSearchPage';
import FilterCriteria from '../pages/tripresult/TripSearchFilterModel';
import SearchCriteria, { LocationType } from '../models/SearchCriteria';
import LocationSelectionPage from '../pages/locationselection/LocationSelectionPage';
import OperatorInfoPage from '../pages/operatorinfo/OperatorInfoPage';
import { SubFsm } from 'little-fsm';
import { ApiService } from '../ApiService';
import { LocationDTO, SourceLocationDTO, TripDTO, TripResultDTO } from '../apiclient/ApiDtos';

export type SearchStatus = 'none' | 'pending' | 'success';

let cachedOperatorImages = new Map<string, string[]>();
let scrollToResultId:string|null = null;

export function buildTripSearchPresenter(
    appContext: AppContext, 
    apiService: ApiService, 
    sourceLocations: SourceLocationDTO[],
    shuttleSources: SourceLocationDTO[],
    smallCarSampleImageUrlPath: string,
    subFsm:SubFsm<TripSearchFsmScheme>): {render:() => m.Vnode} {

    let currOperatorPhotoUrls: undefined | 'fetching' | string[] = undefined;
    
    subFsm.setEnterEffect('showing_results', context => {
        if(scrollToResultId) {
            setTimeout(() => {
                let elem = document.getElementById(scrollToResultId!);
                if(elem) {
                    elem.scrollIntoView()
                };
                scrollToResultId = null;
            }, 100);   
        }
    });

    subFsm.setEnterEffect('search_progressing', context => {
        console.debug("excuting effect for search_progressing with criteria : ", context.searchCriteria);
        apiService.searchTrips(context.searchCriteria).then(errorOrResults => {
            if(errorOrResults.right) {
                let resultAggregate = errorOrResults.right;
                console.log("Got trip results of size: ", resultAggregate.data.length);
                console.log("The results are : ", resultAggregate.data);
                subFsm.processEvent('search_succeeded', {searchResults: resultAggregate.data});
            } else {
                subFsm.processEvent('search_failed', {errorMessage: errorOrResults.left.title});
            }            
        });        
    });
    
    subFsm.setEnterEffect("showing_operator_details", context => { 
        if(cachedOperatorImages.has(context.selectedOperator!.id)) {
            currOperatorPhotoUrls = cachedOperatorImages.get(context.selectedOperator!.id);
        } else {
            currOperatorPhotoUrls = 'fetching';  
            apiService.getOperatorPhotos(context.selectedOperator!.id).then(result => {
                if(result.right){
                    console.log("Got operator photoUrls", result);
                currOperatorPhotoUrls = result.right;
                cachedOperatorImages.set(context.selectedOperator!.id, currOperatorPhotoUrls)
                }
            });
        }
    });   

    return {
        render() {
            let context = subFsm.getCurrentContext(); 
            let substate = subFsm.getCurrentSubState();  
            if(substate == 'selecting_location') {
                return m(LocationSelectionPage, {
                    appContext: appContext,
                    messageProvider: appContext.getMessageProvider(),
                    title: context.selectingLocationType == 'source'? 
                        appContext.getMessageProvider().get("search.choose_source_location"):
                        appContext.getMessageProvider().get("search.choose_destination_location"),
                    locations: context.selectingLocationType == 'source'? 
                        (context.searchCriteria.isSmallCar? shuttleSources: sourceLocations )
                        : context.searchFormModel.sourceLocation?.destinations || [],
                    onLocationSelected: (location: LocationDTO) => {
                        subFsm.processEvent("location_selected", {
                            locationType: context.selectingLocationType!, 
                            location: location
                        });
                    },
                    onClose: () => {
                        subFsm.processEvent('back', {});
                    }
                });
            } else if(substate == 'showing_operator_details') {
                return m(OperatorInfoPage, {
                    appContext: appContext,
                    operator: context.selectedOperator!,
                    data: (currOperatorPhotoUrls)? currOperatorPhotoUrls : 'fetching',  
                    onBackPressed: () => {
                        subFsm.processEvent('back', {});                        
                    },  
                })
            } else {
                return m(TripSearchPage, {
                    appContext: appContext,
                    smallCarSampleImageUrlPath: smallCarSampleImageUrlPath,
                    sourceLocations: sourceLocations,
                    shuttleSources: shuttleSources,
                    stateData: context,   
                    isOnSearchFailState: (substate == 'showing_error'),
                    isFetching: substate == 'search_progressing',
                    isFetchingCancellationRequested: false,                 
                    onBackPressed: () => {
                        subFsm.processEvent('back', {})
                    },
                    onAdvancedFilterRequested: (filterCriteria:FilterCriteria) => {
                        // not supported
                    },
                    onSearch: (searchCriteria: SearchCriteria) => {
                        console.log("Search criteria: ", searchCriteria)
                        subFsm.processEvent('search_requested', {searchCriteria: searchCriteria});
                    },
                    onFilterApplied: (filterCriteria:FilterCriteria) => {
                        subFsm.processEvent('filters_applied', {filterCriteria:filterCriteria});
                    },
                    onTripResultSelected: (result: TripResultDTO) => {
                        scrollToResultId = result.id;
                        subFsm.processEvent('result_selected', {tripSearchResult: result})
                       /*  if(result.isSeatSelectionAllowed) {
                            scrollToResultId = result.id;
                            subFsm.processEvent('result_selected', {tripSearchResult: result})
                        }  */
                    },
                    onLocationSelectionRequested: (locationType: LocationType) => {
                        subFsm.processEvent('location_requested', {locationType:locationType});
                        //fsm.processEvent("location_selection_requested", {locationType: locationType});
                    },
                    onOperatorDetailsSelected: (tripResult: TripDTO) => {
                        scrollToResultId = tripResult.id;
                        subFsm.processEvent("operator_details_requested", {operator: tripResult.operator});
                    },
                    onSearchCancellationConfirmed: () => {
                        subFsm.processEvent('search_cancelled', {})
                    },
                    onSearchCancellationRejected: () => {
                        subFsm.processEvent("search_resumed", {})
                    },
                });
            }
        }
    }
}